import React, { FunctionComponent } from 'react';
import { boardSelectors } from '../../../../../../../../app/resource/boards/board/board.selectors';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { ITaskBreadcrumbProps } from './types';
import { meetingSimpleSelectors } from '../../../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { boardListSelectors } from '../../../../../../../../app/resource/boards/boardList/boardList.selectors';
import { IBoardList } from '../../../../../../../../app/resource/boards/boardList/boardList.types';
import { ITaskSimple } from '../../../../../../../../app/resource/task-simple/task-simple.types';
import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';

export const TaskBreadcrumb: FunctionComponent<ITaskBreadcrumbProps> = ({ meetingId, taskId, boardListId }) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '') as ITaskSimple;
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, task?.meetingIds[0] ?? meetingId);
  const boardList = useSelectWithParams(
    boardListSelectors.selectResourceById,
    task?.taskTypeId ?? boardListId,
  ) as IBoardList;
  const board = useSelectWithParams(boardSelectors.selectResourceById, task?.boardId ?? boardList?.boardId);

  const isHomePage = window.location.href.endsWith('/home');
  return (
    <div className="ln d-inline">
      {isHomePage ? (
        <>
          <span className="link blueGray">{meeting?.title}</span>
          {task?.taskTypeId ? (
            <>
              <span className="blueGray">{` > `}</span>
              <span className="link blueGray">{task?.boardName ?? board?.name}</span>
              <span className="blueGray">{` > `}</span>
              <span className="link blueGray">{task?.taskTypeName ?? boardList?.name}</span>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          {task?.taskTypeId ? (
            <>
              <span className="link darkGray">{task?.boardName ?? board?.name}</span>
              <span className="darkGray">{` > `}</span>
              <span className="link darkGray">{task?.taskTypeName ?? boardList?.name}</span>
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};
